/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMcpVaultDeleteCredential } from "../../funcs/llmMcpVaultDeleteCredential.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteMcpCredentialRequest$inboundSchema,
};

export const tool$llmMcpVaultDeleteCredential: ToolDefinition<typeof args> = {
  name: "llm-mcp-vault-delete-credential",
  description: `Delete MCP credential

Revokes a user-owned MCP credential.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMcpVaultDeleteCredential(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
